import { zapiPlayOptions } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayVod = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getPlayerZapi();
    return player.playVod(parameters.termToken, parameters.teasableId, 
    // @ts-expect-error defined as string
    parameters.teasableType, zapiPlayOptions(parameters.options));
};
